import dynamic from 'next/dynamic';
import { LegalPageContentProps } from 'sly/legalPage/LegalPageContent/LegalPageContent.types';

const LegalPageContentPrivacy = dynamic(
  () => import('sly/legalPage/LegalPageContent/LegalPageContentPrivacy')
);
const LegalPageContentTOS = dynamic(
  () => import('sly/legalPage/LegalPageContent/LegalPageContentTOS')
);

export default function LegalPageContent({ legalPage }: LegalPageContentProps) {
  return (
    <div
      className='relative my-0 mx-auto w-full py-0 px-4 md:w-[var(--col8)] md:p-0 lg:w-[var(--col12)]'
      data-tp-id='gen-div-9045ac1d-4835-41e8-bfd8-beb41602e61b'
    >
      <div
        className='mt-16 lg:flex'
        data-tp-id='gen-div-ec1a1f12-b112-4729-aeb8-14f484b839a8'
      >
        <div
          className='mb-16 text-slate-lighter-40 lg:order-1 lg:mr-6 lg:w-[var(--col8)]'
          data-tp-id='gen-div-082c8209-f6b0-42f0-b5ea-47032bc0faa3'
        >
          {legalPage === 'privacy' ? (
            <LegalPageContentPrivacy />
          ) : (
            <LegalPageContentTOS />
          )}
        </div>
      </div>
    </div>
  );
}
